<template>
    <div class="card-body maxheight">
        <div class="row card-title">
            <h3 class="mx-auto text-left">{{ data.title }}</h3>
        </div>
        <hr>
        <div class="row mx-3 mt-2 justify-content-center">
            <div class="col-8">
            <p v-for="(item, index) in data.responses" :key="index">
                <span v-for="(str, idx) in item" :key="idx">
                    <strong v-if="idx == 0">{{ str }}</strong>
                    <span v-else><br> {{ str }}</span>
                </span>
            </p>
            </div>
        </div>
    </div>
    <div class="card-footer border border-rounded">
        <div class="row justify-content-center">
            <div @click="$emit('nextQuestion', 3, true)" class="btn btn-small nsc-cta blue mx-2 my-2">
                Next
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "InformedConsent",
    props: ["data"],
    emits: ["nextQuestion"],
}
</script>